<template>
  <div class="zones-size-table-container">
    <table class="zones-size-table">
      <thead>
        <tr>
          <th><strong>{{ $txt.zone }}</strong></th>
          <th><strong>{{ $txt.cathode_area }}</strong></th>
          <th><strong>{{ $txt.building }}</strong></th>
          <th><strong>{{ $txt.anode_type }}</strong></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="zone in zones" :key="zone.id">
          <td>{{ zone.name }}</td>
          <td>{{ zone.dto && zone.dto.cathodeArea != null ? zone.dto.cathodeArea : '' }}</td>
          <td>{{ zone.dto && zone.dto.building ? zone.dto.building : '' }}</td>
          <td>{{ zone.dto && zone.dto.comment ? zone.dto.comment : '' }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
// Presentational preview of the project zones-info table. Mirrors exactly what
// generation emits as a native docx table (see ProjectReportTab: anode type =
// zone.dto.comment). No image export — the report builds the table natively.
export default {
  name: "ZonesInfoTable",
  props: {
    zones: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style scoped>
.zones-size-table-container {
  display: inline-block;
  background: #fff;
}
.zones-size-table {
  border-collapse: collapse;
  font-family: Arial, Helvetica, sans-serif;
  font-size: 13px;
}
.zones-size-table th,
.zones-size-table td {
  border: 1px solid #333;
  padding: 4px 10px;
  text-align: left;
}
.zones-size-table th {
  font-weight: normal;
  background: #fff;
}
</style>
